import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../commonComponents/translate';
import surveyProp from '../../survey/propTypes/surveyProp';
import FormInput from '../../../commonComponents/forms/FormInput';
import AccessSessionProp from '../../../commonComponents/propTypes/accessSessionProp';
import { SESSION_MODE } from '../../../services/utilityFunctions';
import BravonRadioCheckbox from '../../../commonComponents/forms/inputs/BravonRadioCheckbox';

function TabClose({ t, accessSession, formState, documents, surveys, select, createInput, handleChange, isFinished }) {
  const handleFileChange = data => {
    const docs = [...data.map(file => ({
      type: 'none',
      file,
    }))];
    handleChange('documents')(docs);
  };
  return (
    <div className="tab6-close">
      <div className="row">
        <div className="col-lg-6 col-12 block-rewards" style={{ height: 'max-content' }}>
          <h4 className="title-rewards_surveys">{t('access_session.detail.surveys')}</h4>
          <div className="row margin-top-15">
            <div className="col-2" />
            <div className="margin-left-5 col-9 margin-bottom-20">
              <BravonRadioCheckbox
                fieldName="promoteSurvey"
                initialState={formState.promoteSurvey}
                handleChange={handleChange}
                label="access_session.detail.promoteSession"
                isDisabled={isFinished}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 p-0">
              {select(
                'survey',
                surveys.map(c => ({ id: c._id, text: c.title })),
                'col-lg-2 col-12 survey-label',
                'col-lg-9 col-12',
              )}
            </div>
          </div>
        </div>
        <div className="col-lg-6 col-12 mobile-session-details">
          <div className="col-lg-12 block-rewards">
            <h4 className="title-rewards_documents">{t('access_session.detail.documents')}</h4>
            <div className="row justify-content-center margin-top-15">
              <div className="col-12">
                <BravonRadioCheckbox
                  fieldName="documentsAvailableOnlyInTheEnd"
                  hasHint
                  initialState={formState.documentsAvailableOnlyInTheEnd}
                  handleChange={handleChange}
                />
                <div className="row w-100 m-0">
                  <div className="col-lg-12 p-0">
                    <FormInput
                      id="document"
                      name="document"
                      value={JSON.stringify(documents.map(doc => doc.file))}
                      onChange={handleFileChange}
                      placeholder={
                        <>
                          <i className="la la-plus-circle" aria-hidden="true" />
                          {t('access_session.detail.addDocument')}
                        </>
                      }
                      labelClassName="col-3 text-right"
                      containerClassName="docContainer"
                      type="dropZone"
                      groupProps={{ className: 'row' }}
                      inputProps={{
                        isImage: false,
                        maxFiles: 20,
                      }}
                      disabled={isFinished}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      { (accessSession.mode === SESSION_MODE.PUBLIC && accessSession.shareLink) && (
        <div className="row">
          <div className="col-lg-8 col-12 block-rewards">
            <h4 className="title-rewards_surveys">{t('access_session.detail.shareLink.title')}</h4>
            <div className="row">
              <div className="col-lg-10">
                {createInput(
                  'shareLink',
                  'text',
                  false,
                  'col-lg-2 col-12 share-link-label',
                  'col-lg-9 col-12',
                  accessSession.shareLink,
                )}
              </div>
              <div className="col-lg-1">
                <button
                  type="button"
                  className="btn m-btn--pill btn-metal navigation-button"
                  onClick={() => {
                    navigator.clipboard.writeText(accessSession.shareLink);
                  }}
                >
                  <i className="fa fa-copy" />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

TabClose.propTypes = {
  /** Translation function */
  t: PropTypes.func.isRequired,
  accessSession: PropTypes.shape(AccessSessionProp.propType).isRequired,
  select: PropTypes.func.isRequired,
  createInput: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  documents: PropTypes.arrayOf(PropTypes.object),
  surveys: PropTypes.arrayOf(PropTypes.shape(surveyProp.propType))
    .isRequired,
  formState: PropTypes.arrayOf(
    PropTypes.shape({
      documents: PropTypes.arrayOf(PropTypes.object),
      survey: PropTypes.string,
      documentsAvailableOnlyInTheEnd: PropTypes.string,
    })).isRequired,
  isFinished: PropTypes.bool,
};
TabClose.defaultProps = {
  documents: [],
  isFinished: false,
};

export default translate(TabClose);
